<template>
    <div class="avatar" :class="{empty : imageSet}">
        <div class="image" :style="imageStyle"></div>
    </div>
</template>

<script>
    export default {
        name: 'Avatar',
        components: {},
        props: {
            image : {
                type: String,
                default: ''
            }
            
        },
        computed: {
            imageSet() {
                if (this.image != ''){
                    return false;
                } else {
                    return true;
                }
            },
            imageStyle() {
                return 'background-image: url(' + this.image + ');';
            }
        },
        data: function() {
            return {

            };
        }
    };
</script>

<style scoped>
    
    .avatar {background-color: #D8D8D8; width: 7.5em; height: 7.5em; border-radius: 50%; border: solid #fff .5em; box-shadow: 0 0 .75em 0 rgba(0,0,0,0.25); position: relative; margin: auto; overflow: hidden;}
        .avatar.empty {}
        .avatar.empty:before {content: ''; display: block; width: 40%; height: 40%; border-radius: 50%; background-color: #8E8E8E; position: absolute; top: 20%; left: 0; right: 0; margin: auto;}
        .avatar.empty:after {content: ''; display: block; width: 80%; height: 100%; border-radius: 50%; background-color: #8E8E8E; position: absolute; top: 63%; left: 0; right: 0; margin: auto;}
            .avatar .image {background-size: cover; background-position: center; width: 7.5em; height: 7.5em;}
            .avatar.empty .image {display: none;}
    
</style>